// Code generated by protoc-gen-family-http. DO NOT EDIT.
// source: maintenance.proto

import type { AxiosInstance } from 'axios';
import { buildPath, unwrapEnvelope, Envelope } from '../contracts-runtime';
import { Empty } from "./google/protobuf/empty";
import { Appliance, ApplianceListResponse, ApplianceTodosResponse, ApplyResearchRequest, ApplyResearchResponse, CreateApplianceRequest, CreateServiceRecordPathRequest, DeleteApplianceRequest, DeleteServiceRecordRequest, GetApplianceRequest, GetServiceRecordRequest, ListServiceRecordsRequest, ResearchResult, ServiceRecord, ServiceRecordListResponse, StartResearchResponse, UpcomingMaintenanceResponse, UpdateAppliancePathRequest, UpdateServiceRecordRequest } from "./maintenance";

// ─── MaintenanceService ──────────────────────────────────

export const MaintenanceService_CreateApplianceRoute = "POST /api/v1/maintenance/appliances";
export const MaintenanceService_ListAppliancesRoute = "GET /api/v1/maintenance/appliances";
export const MaintenanceService_UpcomingMaintenanceRoute = "GET /api/v1/maintenance/upcoming";
export const MaintenanceService_GetApplianceRoute = "GET /api/v1/maintenance/appliances/{id}";
export const MaintenanceService_ListApplianceTodosRoute = "GET /api/v1/maintenance/appliances/{id}/todos";
export const MaintenanceService_UpdateApplianceRoute = "PATCH /api/v1/maintenance/appliances/{id}";
export const MaintenanceService_DeleteApplianceRoute = "DELETE /api/v1/maintenance/appliances/{id}";
export const MaintenanceService_CreateServiceRecordRoute = "POST /api/v1/maintenance/appliances/{id}/records";
export const MaintenanceService_ListServiceRecordsRoute = "GET /api/v1/maintenance/appliances/{id}/records";
export const MaintenanceService_GetServiceRecordRoute = "GET /api/v1/maintenance/appliances/{id}/records/{record_id}";
export const MaintenanceService_UpdateServiceRecordRoute = "PATCH /api/v1/maintenance/appliances/{id}/records/{record_id}";
export const MaintenanceService_DeleteServiceRecordRoute = "DELETE /api/v1/maintenance/appliances/{id}/records/{record_id}";
export const MaintenanceService_StartApplianceResearchRoute = "POST /api/v1/maintenance/appliances/{id}/research";
export const MaintenanceService_GetApplianceResearchRoute = "GET /api/v1/maintenance/appliances/{id}/research";
export const MaintenanceService_ApplyApplianceResearchRoute = "POST /api/v1/maintenance/appliances/{id}/research/{research_id}/apply";

export const maintenanceService = {
  async createAppliance(client: AxiosInstance, req: CreateApplianceRequest): Promise<Appliance> {
    const path = buildPath("/api/v1/maintenance/appliances", {});
    const res = await client.post<Envelope<unknown>>(path, CreateApplianceRequest.toJSON(req));
    return Appliance.fromJSON(unwrapEnvelope(res.data));
  },
  async listAppliances(client: AxiosInstance, req: Empty): Promise<ApplianceListResponse> {
    const path = buildPath("/api/v1/maintenance/appliances", {});
    const res = await client.get<Envelope<unknown>>(path, { params: Empty.toJSON(req) });
    return ApplianceListResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async upcomingMaintenance(client: AxiosInstance, req: Empty): Promise<UpcomingMaintenanceResponse> {
    const path = buildPath("/api/v1/maintenance/upcoming", {});
    const res = await client.get<Envelope<unknown>>(path, { params: Empty.toJSON(req) });
    return UpcomingMaintenanceResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async getAppliance(client: AxiosInstance, req: GetApplianceRequest): Promise<Appliance> {
    const path = buildPath("/api/v1/maintenance/appliances/{id}", { id: String(req.id) });
    const res = await client.get<Envelope<unknown>>(path, { params: GetApplianceRequest.toJSON(req) });
    return Appliance.fromJSON(unwrapEnvelope(res.data));
  },
  async listApplianceTodos(client: AxiosInstance, req: GetApplianceRequest): Promise<ApplianceTodosResponse> {
    const path = buildPath("/api/v1/maintenance/appliances/{id}/todos", { id: String(req.id) });
    const res = await client.get<Envelope<unknown>>(path, { params: GetApplianceRequest.toJSON(req) });
    return ApplianceTodosResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async updateAppliance(client: AxiosInstance, req: UpdateAppliancePathRequest): Promise<Appliance> {
    const path = buildPath("/api/v1/maintenance/appliances/{id}", { id: String(req.id) });
    const res = await client.patch<Envelope<unknown>>(path, UpdateAppliancePathRequest.toJSON(req));
    return Appliance.fromJSON(unwrapEnvelope(res.data));
  },
  async deleteAppliance(client: AxiosInstance, req: DeleteApplianceRequest): Promise<Empty> {
    const path = buildPath("/api/v1/maintenance/appliances/{id}", { id: String(req.id) });
    const res = await client.delete<Envelope<unknown>>(path, { params: DeleteApplianceRequest.toJSON(req) });
    return Empty.fromJSON(unwrapEnvelope(res.data));
  },
  async createServiceRecord(client: AxiosInstance, req: CreateServiceRecordPathRequest): Promise<ServiceRecord> {
    const path = buildPath("/api/v1/maintenance/appliances/{id}/records", { id: String(req.id) });
    const res = await client.post<Envelope<unknown>>(path, CreateServiceRecordPathRequest.toJSON(req));
    return ServiceRecord.fromJSON(unwrapEnvelope(res.data));
  },
  async listServiceRecords(client: AxiosInstance, req: ListServiceRecordsRequest): Promise<ServiceRecordListResponse> {
    const path = buildPath("/api/v1/maintenance/appliances/{id}/records", { id: String(req.id) });
    const res = await client.get<Envelope<unknown>>(path, { params: ListServiceRecordsRequest.toJSON(req) });
    return ServiceRecordListResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async getServiceRecord(client: AxiosInstance, req: GetServiceRecordRequest): Promise<ServiceRecord> {
    const path = buildPath("/api/v1/maintenance/appliances/{id}/records/{record_id}", { id: String(req.id), record_id: String(req.record_id) });
    const res = await client.get<Envelope<unknown>>(path, { params: GetServiceRecordRequest.toJSON(req) });
    return ServiceRecord.fromJSON(unwrapEnvelope(res.data));
  },
  async updateServiceRecord(client: AxiosInstance, req: UpdateServiceRecordRequest): Promise<ServiceRecord> {
    const path = buildPath("/api/v1/maintenance/appliances/{id}/records/{record_id}", { id: String(req.id), record_id: String(req.record_id) });
    const res = await client.patch<Envelope<unknown>>(path, UpdateServiceRecordRequest.toJSON(req));
    return ServiceRecord.fromJSON(unwrapEnvelope(res.data));
  },
  async deleteServiceRecord(client: AxiosInstance, req: DeleteServiceRecordRequest): Promise<Empty> {
    const path = buildPath("/api/v1/maintenance/appliances/{id}/records/{record_id}", { id: String(req.id), record_id: String(req.record_id) });
    const res = await client.delete<Envelope<unknown>>(path, { params: DeleteServiceRecordRequest.toJSON(req) });
    return Empty.fromJSON(unwrapEnvelope(res.data));
  },
  async startApplianceResearch(client: AxiosInstance, req: GetApplianceRequest): Promise<StartResearchResponse> {
    const path = buildPath("/api/v1/maintenance/appliances/{id}/research", { id: String(req.id) });
    const res = await client.post<Envelope<unknown>>(path, GetApplianceRequest.toJSON(req));
    return StartResearchResponse.fromJSON(unwrapEnvelope(res.data));
  },
  async getApplianceResearch(client: AxiosInstance, req: GetApplianceRequest): Promise<ResearchResult> {
    const path = buildPath("/api/v1/maintenance/appliances/{id}/research", { id: String(req.id) });
    const res = await client.get<Envelope<unknown>>(path, { params: GetApplianceRequest.toJSON(req) });
    return ResearchResult.fromJSON(unwrapEnvelope(res.data));
  },
  async applyApplianceResearch(client: AxiosInstance, req: ApplyResearchRequest): Promise<ApplyResearchResponse> {
    const path = buildPath("/api/v1/maintenance/appliances/{id}/research/{research_id}/apply", { id: String(req.id), research_id: String(req.research_id) });
    const res = await client.post<Envelope<unknown>>(path, ApplyResearchRequest.toJSON(req));
    return ApplyResearchResponse.fromJSON(unwrapEnvelope(res.data));
  },
};

